import { Icon } from '../components/index.js'

export interface CommandPaletteButtonProps {
  onOpen: () => void
  /** `sidebar` is the full-width search field at the top of the sidebar — the
   * one place the palette lives in Nocturne 2; `pill` is the compact control
   * for anywhere rendered outside the shell. */
  variant?: 'sidebar' | 'pill'
}

/**
 * The visible way into the command palette. ⌘K/Ctrl+K is wired globally in
 * Shell.tsx, but a mouse-only user needs something to click — so the sidebar
 * carries a search field that opens it.
 */
export function CommandPaletteButton({ onOpen, variant = 'pill' }: CommandPaletteButtonProps) {
  if (variant === 'sidebar') {
    return (
      <button type="button" onClick={onOpen} aria-label="Open the command palette" className="lc-search-field">
        <Icon name="MagnifyingGlass" size={15} />
        <span style={{ flex: 1, textAlign: 'left' }}>Search</span>
        <kbd aria-hidden="true">⌘K</kbd>
      </button>
    )
  }
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Open the command palette"
      className="row btn btn-secondary"
      style={{ flex: 'none', gap: 6, fontSize: 12 }}
    >
      <Icon name="MagnifyingGlass" size={13} />
      <span aria-hidden="true">⌘K</span>
    </button>
  )
}
